import React from 'react'
import { Spinner } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const SearchingOverlay = () => {
  const { t } = useTranslation('SearchingOverlay')

  return (
    <div
      className="d-flex flex-row bg-dark text-white lead justify-content-center align-items-center"
      style={{
        opacity: '50%',
        position: 'absolute',
        top: 0,
        height: '100%',
        width: '100%'
      }}
    >
      <Spinner className="me-3" />
      {t('searching')}
    </div>
  )
}

export default SearchingOverlay
